import Vue from 'vue'
import Router from 'vue-router'

import Aloitus from '@/views/Aloitus'
import Ryhtyminen from '@/views/Ryhtyminen'
import Selvitys from '@/views/Selvitys'
import Jarjestelmat from '@/views/Jarjestelmat'
import Rakennetyypit from '@/views/Rakennetyypit'
import Kustannukset from '@/views/Kustannukset'
import Kilpailuta from '@/views/Kilpailuta'
import PrintItem from '@/views/PrintItem'
import Page from '@/views/Page'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Aloitus',
      component: Aloitus
    },
    {
      path: '/hanke',
      name: 'Hanke',
      component: Ryhtyminen
    },
    {
      path: '/puunkaytonmahdollisuus',
      name: 'Selvitys',
      component: Selvitys
    },
    {
      path: '/jarjestelmat',
      name: 'Jarjestelmat',
      component: Jarjestelmat
    },
    {
      path: '/rakennetyypit',
      name: 'Rakennetyypit',
      component: Rakennetyypit
    },
    {
      path: '/kustannukset/:kt?',
      name: 'Kustannukset',
      component: Kustannukset
    },
    {
      path: '/kilpailuta',
      name: 'Kilpailuta',
      component: Kilpailuta
    },
    {
      path: '/print/:itemId/:kt',
      name: 'PrintItem',
      component: PrintItem
    },
    {
      path: '/:slug',
      name: 'Page',
      component: Page
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js